import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchPeriods} from '../../actions';
import { Container, Row, Col, Nav, NavItem, Tooltip } from 'reactstrap';

import infoIcon from '../../images/info-icon.svg';
import closeIcon from '../../images/close@3x.png';

import RentCycleConstants from '../../constants/RentCycleConstants';
import {sectorDetails} from '../../helpers/Utils';

import MarketImage from '../Common/MarketImage';
import MarketFooter from "./MarketFooter";
import MetricConverter from '../Common/MetricConverter';
import classnames from 'classnames';

const subMarket = [{key: "submarket1", desc: "submarket1Desc"}, {
    key: "submarket2",
    desc: "submarket2Desc"
}, {key: "submarket3", desc: "submarket3Desc"}];

class MarketDetailPanel extends React.Component {
    constructor(props) {

        super(props);
        //  this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: false,
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
            isOpenSource: false,
            posColor: '',
            closeButtonVisible: props.closeButtonVisible ? props.closeButtonVisible : false,
            comparisonVisible: props.comparisonVisible
        };
    }    
    toggleSource = () => {
        this.setState({isOpenSource: !this.state.isOpenSource});
    };

    renderPopulationSource() {
        return (this.state.closeButtonVisible ?
            (this.props.marketCompareQuarters[0] ? "Source: " + this.props.marketCompareQuarters[0].populationSource : "Source: not provided") :
            (this.props.marketquarters[0] ? "Source: " + this.props.marketquarters[0].populationSource : "Source: not provided"));
    }

    getCurrentPositon() {
        let latestQuarter = (this.props.periodList[this.props.periodList.length - 1]);
        let filteredLists = this.props.marketquarters.filter(function (x) {
            return x.period === latestQuarter;
        });

        if (this.state.closeButtonVisible) {
            filteredLists = [this.props.marketCompareQuarters[this.props.marketCompareQuarters.length - 1]];
        }

        return (filteredLists[0] ? filteredLists[0].position : 0);
    }

    displaySectorTextWithColor() {
        let position = parseInt(this.getCurrentPositon());
        const {sectorColor, sectorText} = sectorDetails(position);
        let defColors = document.getElementsByClassName('positioncolor');

        if (this.state.closeButtonVisible) {
            defColors = document.getElementsByClassName('positioncolorRight');
        }
        Array.from(defColors).forEach(defColor => {
            if (defColor !== undefined) {
                defColor.setAttribute("style", "color:" + sectorColor);
            }
        })

        return sectorText;
    }

    handleInfoClicked = (index) => {
        this.setState((state) => ({toolTipIndex: state.toolTipIndex === index ? null : index}))
    }

    findLastIndex = (list) => {
        let i = -1
        if (list[0]) {
            for (let index = 0; index < subMarket.length; index++) {
                const element = subMarket[index];
                if (list[0][element.key]) {
                    i = index
                }
            }
        }
        return i;
    }

    componentWillReceiveProps({props}) {
        if (props) {
            this.setState({comparisonVisible: props.comparisonVisible});
        }
    }

    componentDidMount()
    {
      //when we copy paste detail url, periodList is not avaialble
      if(this.props.periodList.length <=0)
      {
        this.props.fetchPeriods();
      }
    }
    
    render() {
        const { enabled } = this.state;
        const headingClasses = classnames(
            'font-weight-light h2 mb-0 pl-4',
            enabled ? 'text-dark' : 'text-secondary'
          );

        const key = 'Test';

        const {marketselected, marketquarters} = this.props;
        const marketCompareQuarters = this.props.marketCompareQuarters;
        const ie = window.navigator.userAgent.indexOf('Trident') !== -1;
        const lastComparisonIndex = this.findLastIndex(marketCompareQuarters);
        const lastIndex = this.findLastIndex(marketquarters);

        const wrapperClasses = this.props.rightPanel && ie && this.state.comparisonVisible ?
            'custom-container-comparison compare-market-panel' : 'custom-container-comparison';

        return (
            <div className={wrapperClasses}>
                <Container className={this.state.comparisonVisible ? 'custom-container-comparison' : 'custom-container'}>
                    <Row className={this.state.comparisonVisible ? 'custom-row-comparison' : 'custom-row'}>
                        <Col className="no-gutter" style={{width: '280px'}}>
                            <Nav vertical color="light" className="ml-auto" navbar style={{width: '280px'}}>
                                <NavItem>
                                    <MarketImage devicetype="desktop" rightPanel={this.props.rightPanel}
                                                 comparisonVisible={this.state.comparisonVisible}/>
                                    {this.state.closeButtonVisible ?
                                        <img src={closeIcon} alt="close" onClick={this.props.onClosePanel}
                                             className="rightPanelClose cursor-pointer"/> : null}
                                </NavItem>
                                <NavItem className={this.state.comparisonVisible ? 'marketTitle-comparison' : 'marketTitle'}>
                                    {this.state.closeButtonVisible ?
                                        marketCompareQuarters[0] && marketCompareQuarters[0].market :
                                        marketselected}
                                </NavItem>
                                <NavItem className={this.state.comparisonVisible ?
                                            'container-item-comparison' : 'container-item'}>
                                      <span>{RentCycleConstants.POPULATION}
                                          {this.state.closeButtonVisible ?
                                              <img href="#" id="sourcetooltipRight" src={'#{rentrackerappimages}#' +'/info-icon.svg'}
                                                   className="ic_info_outline_24px cursor-pointer" alt="infoIcon"
                                                   style={{marginLeft: '5px'}}/> :
                                              <img href="#" id="sourcetooltip" src={'#{rentrackerappimages}#' +'/info-icon.svg'}
                                                   className="ic_info_outline_24px cursor-pointer" alt="infoIcon"
                                                   style={{marginLeft: '5px'}}/>  
                                          }
                                          {this.state.closeButtonVisible ?
                                              <Tooltip trigger="legacy" style={{
                                                  textDecoration: "bold",
                                                  fontFamily: "Calibre",
                                                  textAlign: "left",
                                                  color: "white",
                                                  backgroundColor: "#012A2D"
                                              }} placement="bottom-end" isOpen={this.state.isOpenSource} target="sourcetooltipRight"
                                                       toggle={this.toggleSource}>
                                                  {this.renderPopulationSource()}
                                              </Tooltip> :
                                              <Tooltip trigger="legacy" style={{
                                                  textDecoration: "bold",
                                                  fontFamily: "Calibre",
                                                  textAlign: "left",
                                                  color: "white",
                                                  backgroundColor: "#012A2D"
                                              }} placement="bottom-end" isOpen={this.state.isOpenSource} target="sourcetooltip"
                                                       toggle={this.toggleSource}>
                                                  {this.renderPopulationSource()}
                                              </Tooltip>}
                                      </span>

                                    <span className={"nav-item-nowrap item-right-text"}>{this.state.closeButtonVisible ?
                                                marketCompareQuarters.map(y => y.population)[0] :
                                                marketquarters.map(x => x.population)[0]} M</span>
                                </NavItem>
                                <NavItem className={this.state.comparisonVisible ? 'container-item-comparison' : 'container-item'}>
                                    <span >{RentCycleConstants.OVERALL_OFFICE_MARKET_SIZE}</span>
                                    <span className={"nav-item-nowrap market-size-content item-right-text"}>
                                        <MetricConverter 
                                            officerent={this.state.closeButtonVisible ? marketCompareQuarters.map(y => y.overallOfficeMarketSize)[0] : marketquarters.map(x => x.overallOfficeMarketSize)[0]} 
                                            cssclassName={"nav-item-nowrap market-size-content"} />  
                                    </span>
                                </NavItem>
                                <NavItem className={this.state.comparisonVisible ? 'container-item-comparison no-border text-center' : 'container-item no-border text-center'}>
                                    <a target="_blank" rel="noopener noreferrer"
                                       href={this.state.closeButtonVisible ? marketCompareQuarters.map(y => y.url)[0] : marketquarters.map(x => x.url)[0]}
                                       className="external-link-city"
                                       style={{
                                    //        color: '#538184',
                                    //        textDecoration: "underline",
                                    //        fontFamily: "Calibre",
                                    //        fontSize: "16px",
                                    //        fontWeight: "500",
                                        //    lineHeight: "22px",
                                           width: "250px",
                                        //    paddingBottom: "10px"
                                    //     //    textAlign: "center"
                                       }}
                                       >{RentCycleConstants.LEARN_MORE_ABOUT_CBRE}{this.state.closeButtonVisible ? marketCompareQuarters[0] && marketCompareQuarters[0].market : marketselected}</a>
                                </NavItem>
                                <NavItem
                                    className={this.state.comparisonVisible ? 'marketName-comparison' : 'marketName'}>{RentCycleConstants.KEY_SUBMARKETS}</NavItem>
                                {this.state.closeButtonVisible ? (marketquarters[0] && marketCompareQuarters[0] && subMarket.map((element, index) => {
                                    return marketCompareQuarters[0][`${element.key}`] ? (
                                        <NavItem className="container-item-comparison"
                                                 style={lastComparisonIndex === index ? {border: "none"} : {}}
                                                 key={index}>
                                            <span
                                                className="sub-market">{marketCompareQuarters[0][`${element.key}`]}</span>
                                            <img href="#"
                                                 id={this.state.comparisonVisible ? `submarket${index}tooltipRight` : `submarket${index}tooltip`}
                                                 src={'#{rentrackerappimages}#' +'/info-icon.svg'} className="ic_info_outline_24px cursor-pointer"
                                                 alt="infoIcon"/>
                                            <Tooltip trigger="legacy" style={{
                                                textDecoration: "bold",
                                                fontFamily: "Calibre",
                                                textAlign: "left",
                                                color: "white",
                                                backgroundColor: "#012A2D",
                                                arrowColor: "#012A2D"
                                            }} placement="bottom-end" isOpen={this.state.toolTipIndex === index}
                                                     target={`submarket${index}tooltipRight`}
                                                     toggle={() => this.handleInfoClicked(index)}>
                                                {marketCompareQuarters[0][`${element.desc}`]}
                                            </Tooltip>
                                        </NavItem>
                                    ) : null
                                })) : (
                                    marketquarters[0] && subMarket.map((element, index) => {
                                        return marketquarters[0][`${element.key}`] ? (
                                            <NavItem
                                                className={this.state.comparisonVisible ? 'container-item-comparison' : 'container-item'}
                                                style={lastIndex === index ? {border: "none"} : {}} key={index}>
                                                <span className="sub-market">{marketquarters[0][`${element.key}`]}</span>
                                                <img href="#" id={`submarket${index}tooltip`} src={'#{rentrackerappimages}#' +'/info-icon.svg'}
                                                     className="ic_info_outline_24px cursor-pointer" alt="infoIcon"/>
                                                <Tooltip trigger="legacy" style={{
                                                    textDecoration: "bold",
                                                    fontFamily: "Calibre",
                                                    textAlign: "left",
                                                    color: "white",
                                                    backgroundColor: "#012A2D"
                                                }} placement="bottom-end" isOpen={this.state.toolTipIndex === index}
                                                         target={`submarket${index}tooltip`}
                                                         toggle={() => this.handleInfoClicked(index)}>
                                                    {marketquarters[0][`${element.desc}`]}
                                                </Tooltip>
                                            </NavItem>
                                        ) : null
                                    }))}
                                <NavItem
                                    className={this.state.comparisonVisible ? 'marketName-comparison' : 'marketName'}>
                                    {this.props.periodList[this.props.periodList.length - 1]} {RentCycleConstants.OFFICE_DATA}
                                </NavItem>
                                <NavItem
                                    className={this.state.comparisonVisible ? 'container-item-comparison' : 'container-item'}>
                                    <span >{RentCycleConstants.RENT_CYCLE_POSITION}</span>
                                    <span
                                        className={"item-right-text "}>{this.displaySectorTextWithColor()}</span>
                                </NavItem>
                                <NavItem
                                    className={this.state.comparisonVisible ? 'container-item-comparison' : 'container-item'}>
                                    <span >
                                        {RentCycleConstants.OVERALL_RENT_CHANGE}
                                        <br />
                                        {RentCycleConstants.OVERALL_RENT_CHANGE_YOY}
                                    </span>
                                    <span class="item-right-text">{this.state.closeButtonVisible ? marketCompareQuarters.map(y => y.overallRentChange)[0] : marketquarters.map(x => x.overallRentChange)[0]}%</span>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
      marketquarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [],
      marketselected: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : '',
      periodList: state.periodList,
      marketCompareQuarters: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].marketDetails : [],
      marketInfo: state.comparisonMarkets
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPeriods: () => {
        dispatch(fetchPeriods());
       }
  }     
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MarketDetailPanel)
)